@defer (when value()) {
  <app-permissions-form
    [edit]="false"
    [delete]="true"
    [(value)]="value"
    [id]="id"
    [access]="access()"
  ></app-permissions-form>
}
